module.exports = __webpack_public_path__ + "static/img/ck.bbd0bb27.png";